export default {
  MY_AVAILABILITY: {
    TITLE: `My Availabilities`,
    SUMMARY: ``
  },
  CANCEL_MODAL: {
    TITLE: `Are you sure?`,
    SUMMARY: `Deleting an availability cannot be undone.`,
    PRIMARY_ACTION: `Delete availability`
  },
  CREATE_AVAILABILITY: `Create availability`,
  TEMPORARY: `Temporary`,
  NO_AVAILABILITY: `No availabilities to display.`,
  CREATED_ON: `Created on`,
  LAST_UPDATED_ON: `Last updated on`,
  CONTRACT_TYPE_PREVENTS_UPDATING: `One or more of your contract types or permissions prevent updating your availabilities, contact your manager for additional information.`,
  AVAILABILITY_IN_PAST: `This availability has already started and cannot be changed. Duplicate it with a start date in the future to make changes.`,
  AVAILABILITY_APPROVED: `This availability has already been approved and cannot be changed. Duplicate it with a start date in the future to make changes.`
}
